import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * 押すと**別の画面へ移る**セル。表の中でも詳細のヘッダでも使う。
 *
 * 青字＋下線のクリックできる値は、この画面で編集するもの（[[EditableTextCell]] /
 * [[InlineEditCell]]）と、別の画面へ移るものの 2 種類ある。**見た目が同じだと、
 * 押すまでどちらか分からない**ので、末尾に小さなアイコンを添えて見分ける。
 *
 * - 右上向きの矢印（ここ）… 画面が移る
 * - 鉛筆 … その場で直せる
 *
 * `ExternalLink`（四角から矢印が出る形）は使わない。あれは別タブで開く意味で
 * 定着していて、同じアプリの中の移動に使うと新しいタブが開くように見える。
 * 本当に別タブへ出すもの（PDF など）はそちらを使う。
 */
export default function LinkCell({
  to,
  label,
  children,
  bold = false,
}: {
  to: string;
  /** 読み上げ用の説明（例: `見積 Q2026-0001 を開く`）。 */
  label: string;
  children: React.ReactNode;
  /** 行を識別する値（工番・見積番号）は太字にする。 */
  bold?: boolean;
}) {
  return (
    <Link
      to={to}
      aria-label={label}
      // 行全体を押せる表でも、ここでの押下は行の選択に伝播させない。
      onClick={(e) => e.stopPropagation()}
      className="inline-flex max-w-full items-center gap-1 align-top text-brand-500 hover:text-brand-600"
    >
      <span
        className={`truncate underline underline-offset-2 ${bold ? "font-medium" : ""}`}
      >
        {children}
      </span>
      <ArrowUpRight size={12} className="shrink-0" aria-hidden />
    </Link>
  );
}
